import moment from 'moment'
import { TransactionFilters } from '../Transactions/transactionFilters'
import { ChannelType } from '../../models/channelType'
import { SigningTypes } from '../../util/paymentModel'
import { TransactionStatus } from '../../util/transactionConstants'

export const merchantPortalFilter = {
  field: TransactionFilters.CHANNEL_TYPE.value,
  value: ChannelType.MERCHANT_PORTAL,
  type: 'MUST',
  _id: Math.random(),
}
export const notDebitedFilter = {
  field: TransactionFilters.PAYMENT_STATUS.value,
  value: 'debited',
  type: 'MUST_NOT',
  _id: Math.random(),
}
export const notFrozen = {
  field: TransactionFilters.STATUS.value,
  value: 'FROZEN',
  type: 'MUST_NOT',
  _id: Math.random(),
}
export const notAnnulled = {
  field: TransactionFilters.STATUS.value,
  value: 'ANNULLED',
  type: 'MUST_NOT',
  _id: Math.random(),
}
export const notCredited = {
  field: TransactionFilters.PAYMENT_STATUS.value,
  value: 'credited',
  type: 'MUST_NOT',
  _id: Math.random(),
}
export const debitable = {
  field: TransactionFilters.PAYMENT_STATUS.value,
  value: 'debitable',
  type: 'MUST',
  _id: Math.random(),
}
export const signingRequired = {
  field: TransactionFilters.STATUS.value,
  value: [
    TransactionStatus.SIGNING_REQUIRED,
    TransactionStatus.CUSTOMER_INTERACTION_REQUIRED,
  ].join(','),
  type: 'SHOULD',
  _id: Math.random(),
}
export const noSigningRequiredOlderThan30Days = {
  field: TransactionFilters.STATUS.value,
  value: 'SIGNING_REQUIRED',
  type: 'MUST_NOT',
  range: {
    endDate: moment(Date.now()).subtract(31, 'days').toDate(),
  },
  _id: Math.random(),
}
export const noCustomerInteractionRequiredOlderThan30Days = {
  field: TransactionFilters.STATUS.value,
  value: TransactionStatus.CUSTOMER_INTERACTION_REQUIRED,
  type: 'MUST_NOT',
  range: {
    endDate: moment(Date.now()).subtract(31, 'days').toDate(),
  },
  _id: Math.random(),
}
export const showOnlyOngoingOrDelayedPayments = {
  field: TransactionFilters.SHOW_ONLY_ONGOING_OR_DELAYED_PAYMENTS.value,
  value: 'true',
  type: 'MUST',
  _id: Math.random(),
}
export const approvedOrSigned = {
  field: TransactionFilters.STATUS.value,
  value: 'APPROVED,SIGNED',
  type: 'SHOULD',
  _id: Math.random(),
}
export const createStoreFilter = storeId => {
  return {
    field: TransactionFilters.STORE_STORE_ID.value,
    value: storeId,
    type: 'MUST',
    _id: Math.random(),
  }
}
export const signingType = {
  field: 'SIGNING_TYPE',
  value: [SigningTypes.ELECTRONIC, SigningTypes.NOT_APPLICABLE].join(','),
  type: 'SHOULD',
  _id: Math.random(),
}
